export enum EducationIdeaStatus {
  PENDING = 1,
  DONE = 2,
  REJECTED = 3
}
